module.exports = "/images/Submit_3of5.jpg";